import formatByCountry from "./FormatByCountry";

const formatPriceIDR = (price: number, currency: "IDR" | "MYR" = "IDR"): string => {
  if (currency === "IDR") {
    return `${formatByCountry(price, { type: "money", country: "ID" })} IDR`;
  }
  return `RM${formatByCountry(price, { type: "money", country: "MY" })}`;
};
export default formatPriceIDR;
